import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { SKIP_ERROR_INTERCEPTOR } from '@infra/http-interceptors/reedge.error.interceptor';
import { type ChangeLogDTO } from '@api/models';
import { type Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChangeLogService {
  private readonly http = inject(HttpClient);

  get(version: string, skipErrorInterceptor = false): Observable<ChangeLogDTO> {
    const uri = `${environment.api}/change-logs/${version}`;
    const context = new HttpContext().set(SKIP_ERROR_INTERCEPTOR, skipErrorInterceptor);
    return this.http.get<ChangeLogDTO>(uri, { context });
  }

  list(): Observable<ChangeLogDTO[]> {
    const uri = `${environment.api}/change-logs`;
    return this.http.get<ChangeLogDTO[]>(uri);
  }

  delete(version: string): Observable<void> {
    const uri = `${environment.api}/change-logs/${version}`;
    return this.http.delete<void>(uri);
  }

  save(data: ChangeLogDTO): Observable<void> {
    const uri = `${environment.api}/change-logs/${data.version}`;
    return this.http.put<void>(uri, { description: data.description });
  }
}
